import { css } from '@emotion/react'
import settings from '@settings'
import { FC, useCallback } from 'react'
import { TemplateScrollbarProps } from '../types';
import { useColorStore } from '@provider';

export const scrollbarContainer = css({
  position: 'relative',
  width: 'fit-content',
  height: 'fit-content'
})

const TemplateScrollbar: FC<TemplateScrollbarProps> = ({scrollPosition, contentWidth}) => {
    const {leftContentColor, rightContentColor} = useColorStore();
  
    const renderBackgroundColor = useCallback(() => {
        if (rightContentColor === 'light' && leftContentColor === 'light') {
            return settings.colors.light;
        } else if (leftContentColor === 'light' && rightContentColor === 'dark') {
            return settings.colors.light;
        } else if (leftContentColor === 'dark' && rightContentColor === 'light') {
            return settings.colors.dark;
        } else {
            return settings.colors.dark;
        }
    }, [leftContentColor, rightContentColor]);

    return(
        <div css={container}>
        {/* Background Track */}
        <div css={track}>
            {/* Scroll Progress Fill */}
            <div 
            css={[
                progressFill, 
                {
                width: `${(100/contentWidth) * (-scrollPosition)}%`,
                backgroundColor: renderBackgroundColor()
                }
            ]} 

            />

        </div>
            
        </div>
    ) 
}

const container = css({
    position: "fixed",
    zIndex: 3,
    bottom: 0,
    left: 0,
    height: "90px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  })

const track = css({
    position: "relative",
    height: "2px",
    backgroundColor: "#ccc",
    width: "85%",
    margin: 'auto',
    borderRadius: "2px",
    overflow: 'hidden',
  })
const progressFill = css({
    position: "absolute",
    borderRadius: "4px",
    height: '2px',
    transition: "width 0.9s ease-out",
  })



export default TemplateScrollbar